import { Button, CircularProgress, TextField } from '@mui/material'
import React from 'react'
import { PageAlert } from '../../../components'
import { ENV } from '../../../env'
import { useAuth, useInputText } from '../../../hooks'

export default function Form() {
  const { loading, error, login, user } = useAuth()

  const initialValues =
    ENV.VITE_NODE_ENV !== 'development'
      ? { email: user?.email ?? '', password: '' }
      : {
          email: ENV.VITE_DEFAULT_USERNAME,
          password: ENV.VITE_DEFAULT_PASSWORD,
        }
  const input = useInputText(initialValues)

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    const { email, password } = input
    await login({ email, password })
  }

  return (
    <form onSubmit={handleSubmit} className="grid gap-4">
      <TextField
        margin="normal"
        required
        fullWidth
        label="E-mail"
        value={input.email}
        onChange={input.onChange}
        onBlur={input.onBlur}
        error={!!input.errors.email}
        helperText={input.errors.email}
        name="email"
        autoComplete="email"
        autoFocus
        disabled={loading}
      />

      <TextField
        margin="normal"
        required
        fullWidth
        name="password"
        value={input.password}
        onChange={input.onChange}
        label="Palavra-passe"
        type="password"
        id="password"
        autoComplete="current-password"
        disabled={loading}
      />

      {error && (
        <PageAlert
          sx={{ p: 0, mt: 2, border: 'none' }}
          severity="error"
          alertName={error}
        />
      )}

      <Button type="submit" variant="contained" disabled={loading}>
        {loading ? 'A verificar...' : 'Entrar'}
        {loading && <CircularProgress size={24} />}
      </Button>
    </form>
  )
}
